import React, {useEffect, useRef, useState} from 'react';
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-xcode";
import {getEmailConfig, updateEmailConfig} from "../../../../requests/ConfigRequests";
import {createEmailConfig, EmailConfig, EmailTemplate} from "../../../../interfaces/EmailConfig";
import {checkStatus, parseJson, returnNull} from "../../../../fetch";
import {FormattedMessage} from "react-intl";

interface EmailTypes {
    key: string;
    label: string;
}

export function EmailConfiguration(props: {}) {
    const [currentEmailConfig, setCurrentEmailConfig] = useState<EmailConfig>();
    const [selectedKey, setSelectedKey] = useState("registration_request_email");
    const [selectedLanguage, setSelectedLanguage] = useState("en");
    const [emailTemplate, setEmailTemplate] = useState<EmailTemplate>({email: "", language: "", title: ""});

    const emailTypes: EmailTypes[] = [
        {key: "registration_request_email", label: "Registration Request Email"},
        {key: "registration_requestor_email", label: "Registration Requestor Email"},
        {key: "welcome_email_content", label: "Welcome Email Content"},
        {key: "reset_password_email_content", label: "Reset Password Email Content"},
        {key: "confirmation_email_content", label: "Confirmation Email Content"},
        {key: "invoice_receipt_content", label: "Email Receipt"},
    ];

    const languages = [
        {key: "en", label: "English"},
        {key: "fr", label: "French"},
        {key: "de", label: "German"},
        {key: "es", label: "Spanish"},
        {key: "it", label: "Italian"},
        {key: "ja", label: "Japanese"},
        {key: "pt", label: "Portuguese"},
        {key: "ru", label: "Russian"},
    ];

    let fetchData = async () => {
        let config: EmailConfig | null = await getEmailConfig(selectedKey)
            .then(checkStatus(200))
            .then(parseJson)
            .catch(returnNull);
        if (config == null) {
            setCurrentEmailConfig(createEmailConfig(selectedKey));
            createNewTemplate();
        } else {
            setCurrentEmailConfig(config);
            if (config.templates[selectedLanguage]) {
                setEmailTemplate(config.templates[selectedLanguage]);
            } else {
                createNewTemplate();
            }
        }
    };

    function createNewTemplate() {
        setEmailTemplate({title: "", language: selectedLanguage, email: ""});
    }

    useEffect(() => {
        fetchData();
    }, [selectedKey, selectedLanguage]);

    function handleEditorChange(content: string, editor) {
        setEmailTemplate({
            ...emailTemplate,
            email: content
        })
    }

    function handleTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setEmailTemplate({
            ...emailTemplate,
            title: e.target.value
        })
    }

    function saveEmail() {
        if (currentEmailConfig) {
            currentEmailConfig.templates[selectedLanguage] = emailTemplate;
            updateEmailConfig(selectedKey, currentEmailConfig);
        }
    }

    function onEmailChange(e: React.ChangeEvent<HTMLSelectElement>) {
        setSelectedKey(e.target.value);
    }

    function onLanguageChange(e: React.ChangeEvent<HTMLSelectElement>) {
        setSelectedLanguage(e.target.value);
    }

    return (
        <div>
            <div className="row">
                <div className="col-12 card">
                    <div className={"row"}>
                        <div className={"col"}>
                            <select className={"form-control"} onChange={onEmailChange}>
                                {emailTypes.map(_ => <option key={_.key} value={_.key}>{_.label}</option>)}
                            </select>
                        </div>
                        <div className={"col"}>
                            <select className={"form-control"} onChange={onLanguageChange}>
                                {languages.map(_ => <option key={_.key} value={_.key}>{_.label}</option>)}
                            </select>
                        </div>
                        <div className={"col-auto"}>
                            <button className={"btn btn-primary"}
                                    onClick={saveEmail}
                            >
                                <FormattedMessage id={"save"}/>
                            </button>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col"}>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Email Title</label>
                                <input className={"form-control"} type={"text"} value={emailTemplate?.title}
                                       onChange={handleTitleChange}/>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col"}>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Email Body</label>
                                <AceEditor
                                    mode="html"
                                    theme="xcode"
                                    width={'100%'}
                                    onChange={handleEditorChange}
                                    fontSize={14}
                                    highlightActiveLine={true}
                                    wrapEnabled={false}
                                    showPrintMargin={false}
                                    value={emailTemplate?.email}
                                    setOptions={{
                                        enableBasicAutocompletion: false,
                                        enableLiveAutocompletion: false,
                                        enableSnippets: false,
                                        showLineNumbers: true,
                                        tabSize: 2,
                                    }}/>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}